<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">

      </div>
      <div class="header_item">
        <!-- <el-button :size="size" icon="el-icon-search" @click="searchDrawingInfoList(true)">查询</el-button> -->
        <el-button class="search_btn" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
      <div class="header_right">
        <el-button :size="size" icon="el-icon-back" @click="$emit('update:showDrawing', false)">返回</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="drawingDataList"
        height="100%">
        <el-table-column label="序号" align="center" width="80">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="drawNum" label="图纸编号" align="center"></el-table-column>
        <el-table-column prop="drawName" label="图纸名称" align="center"></el-table-column>
        <el-table-column prop="version" label="版本号" align="center"></el-table-column>
        <el-table-column prop="drawAdmin" label="负责人" align="center"></el-table-column>
        <el-table-column label="文件" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" @click="propLookFile(row)">查看文件</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增图纸  修改图纸信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增图纸' : '修改图纸信息'"
      :visible.sync="asyncDrawingData"
      width="35%">
      <el-form ref="form" :model="formDrawingData" :rules="rulesDrawingData" label-width="auto" class="rule_form">
        <el-form-item label="图纸名称：" prop="drawName">
          <el-input v-model="formDrawingData.drawName" :size="size" clearable placeholder="请输入图纸名称"></el-input>
        </el-form-item>
        <el-form-item label="图纸编号：" prop="drawNum">
          <el-input v-model="formDrawingData.drawNum" :size="size" clearable placeholder="请输入图纸编号"></el-input>
        </el-form-item>
        <el-form-item label="版本号：" prop="version">
          <el-input v-model="formDrawingData.version" :size="size" clearable placeholder="请输入版本号"></el-input>
        </el-form-item>
        <el-form-item label="负责人：" prop="drawAdmin">
          <el-input v-model="formDrawingData.drawAdmin" :size="size" clearable placeholder="请输入负责人"></el-input>
        </el-form-item>
        <el-form-item label="文件上传：" prop="drawFileList">
          <upload-file :file-list.sync="formDrawingData.drawFileList">
						<template #info>
							<span>点击上传文件，支持xls、xlsx、ppt、doc、docx、pdf格式</span>
						</template>
          </upload-file>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncDrawingData = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
    <!-- 查看文件 -->
    <look-file :file-list.sync="fileList" :async-file.sync="asyncFile"></look-file>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia';
import { changeSize, throttle } from '../../../plugins/public';
import UploadFile from '../../../components/uploadFile';
import LookFile from '../../../components/LookFile';
  export default {
    name: 'DrawingList',
    props: {
      showDrawing: {
        type: Boolean,
        default: () => {
          return false
        }
      },
      drawTypeId: {
        type: String
      }
    },
    data() {
      var fileMustUpload = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请上传文件'));
        } else if (value.length < 0) {
          callback(new Error('请上传文件'));
        } else {
          this.$refs.form.clearValidate('drawFileList');
          callback();
        }
      };
      return {
        size: changeSize(),
        total: 0,
        pageNum: 1,
        pageSize: 10,
        loading: false,
        drawingDataList: [], // 列表信息
        asyncTitle: true, // true  新增  false 修改
        asyncDrawingData: false, // 弹窗
        formDrawingData: {
          drawFileList: []
        }, // 表单信息
        rulesDrawingData: {
          drawName: [{
            required: true,
            message: '请输入图纸名称',
            trigger: 'blur'
          }],
          drawNum: [{
            required: true,
            message: '请输入图纸编号',
            trigger: 'blur'
          }],
          version: [{
            required: true,
            message: '请输入版本号',
            trigger: 'blur'
          }],
          drawAdmin: [{
            required: true,
            message: '请输入负责人',
            trigger: 'blur'
          }],
          drawFileList: [{
            required: true,
            message: '请上传文件'
          }, {
            validator: fileMustUpload,
            trigger: ['change']
          }]
        }, // 表单校验规则
        fileList: [],
        asyncFile: false
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchDrawingInfoList(true);
    },
    methods: {
      // 获取图纸信息下文件
      async searchDrawFileInfo(drawId) {
        const { data } = await this.$api.Project.searchDrawingFileList({
          drawId: drawId
        })
        return data;
      },
      // 查询图纸信息列表
      searchDrawingInfoList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.drawingDataList = [];
        this.$api.Project.searchDrawingInfoList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          drawTypeId: this.drawTypeId
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.drawingDataList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncDrawingData = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncDrawingData = true;
        this.$set(this.formDrawingData, 'drawTypeId', row.drawTypeId);
        this.$set(this.formDrawingData, 'drawId', row.drawId);
        this.$set(this.formDrawingData, 'drawName', row.drawName);
        this.$set(this.formDrawingData, 'drawNum', row.drawNum);
        this.$set(this.formDrawingData, 'version', row.version);
        this.$set(this.formDrawingData, 'drawAdmin', row.drawAdmin);
        this.searchDrawFileInfo(row.drawId).then(res => {
          this.$set(this.formDrawingData, 'drawFileList', res.list.map(item => {
            const type = item.drawFileName.split('.');
            return {
              id: item.id,
              type: type[type.length - 1],
              name: item.drawFileName,
              url: item.drawFile
            }
          }));
        });
      },
      // 查看文件
      propLookFile(row) {
        this.fileList = [];
        this.searchDrawFileInfo(row.drawId).then(res => {
          let list = res.list.map(item => {
              const type = item.drawFileName.split('.');
              return {
                id: item.id,
                type: type[type.length - 1],
                name: item.drawFileName,
                url: item.drawFile
              }
            })
          this.fileList = list;
        });
        this.asyncFile = true;
      },
      // 删除图纸信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该图纸信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Project.deleteDrawingInfo({drawId: row.drawId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchDrawingInfoList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDrawingData);
            params.drawTypeId = this.drawTypeId;
            params.drawFileList = params.drawFileList.map(item => {
              return {
                drawFile: item.url
              }
            });
            this.$api.Project.insertDrawingInfo(params).then((res) => {
              if(res.success) {
                this.asyncDrawingData = false;
                this.searchDrawingInfoList(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      //  提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formDrawingData);
            params.drawFileList = params.drawFileList.map(item => {
              return {
                drawFile: item.url
              }
            });
            this.$api.Project.insertDrawingInfo(params).then((res) => {
              if(res.success) {
                this.asyncDrawingData = false;
                this.searchDrawingInfoList(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchDrawingInfoList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchDrawingInfoList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      }
    },
    components: {
      UploadFile,
      LookFile
    },
    watch: {
      asyncDrawingData(bol) {
        if(!bol) {
          this.formDrawingData = {
            drawFileList: []
          };
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../style/layout-main.scss';

.main_header {
  position: relative;
}

.header_right {
  position: absolute;
  right: 0;
}
</style>